import React from "react";

const LETTER_STYLE = {
  borderRight: "10px solid white",
  lineHeight: 1.8,
};

function MSquaresHeader(props) {
  return (
    <div
      style={{
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "1fr ".repeat("squares".length),
        justifyContent: "space-between",
        background: "no-repeat center",
        backgroundColor: "rgb(85,85,85)",
        backgroundImage: "url(/i/field.jpg)",
        backgroundSize: "cover",

        color: "white",
        textShadow: "rgb(0 0 0) 0px 0px 5px",
        fontFamily: "league-gothic, sans-serif",
        fontSize: 30,
        textAlign: "center",
      }}
    >
      <div style={LETTER_STYLE}>S</div>
      <div style={LETTER_STYLE}>Q</div>
      <div style={LETTER_STYLE}>U</div>
      <div style={LETTER_STYLE}>A</div>
      <div style={LETTER_STYLE}>R</div>
      <div style={LETTER_STYLE}>E</div>
      <div style={{}}>S</div>
    </div>
  );
}
export default MSquaresHeader;



// WEBPACK FOOTER //
// ./src/MSquaresHeader.js